import { render, staticRenderFns } from "./ActivityRequestModal.vue?vue&type=template&id=2be1bfda&scoped=true&"
import script from "./ActivityRequestModal.vue?vue&type=script&lang=js&"
export * from "./ActivityRequestModal.vue?vue&type=script&lang=js&"
import style0 from "./ActivityRequestModal.vue?vue&type=style&index=0&id=2be1bfda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be1bfda",
  null
  
)

export default component.exports